import React from 'react';

import PropTypes from 'prop-types';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import LiveFeedEntry from '../dashboard/LiveFeed/LiveFeedEntry';
import LiveFeedPost from '../dashboard/LiveFeed/LiveFeedPost';
import colors from '../constants/Colors';

export default function NotesRow({
  note,
  timestamp,
  tags = [],
  user,
  date,
  isCurrentUser,
  hideDivider,
  unread,
  files,
  onPostClick,
  type = '',
  canEdit = false,
  onEdit,
  onDelete,
  lastEditedDate,
  lastEditedByName,
}) {
  const menuOptions = [];
  if (canEdit && onEdit) {
    menuOptions.push({
      title: 'Edit',
      onClick: onEdit,
      iconNode: <EditOutlined />,
    });
  }
  if (canEdit && onDelete) {
    menuOptions.push({
      title: 'Delete',
      style: { color: colors.ONTRACCR_RED },
      onClick: onDelete,
      iconNode: <DeleteOutlined style={{ color: colors.ONTRACCR_RED }} />,
    });
  }

  return (
    <LiveFeedEntry
      unread={unread}
      user={user}
      date={date}
      isCurrentUser={isCurrentUser}
      hideDivider={hideDivider}
      menuOptions={menuOptions}
      lastEditedDate={lastEditedDate}
      lastEditedByName={lastEditedByName}
      extra={(
        <LiveFeedPost
          post={{
            text: note,
            tags,
            files,
            userId: user?.id,
            // Needs createdAt for PostDrawer header
            // https://projectharbour.atlassian.net/browse/HARBOUR-4308
            createdAt: timestamp,
            onPostClick,
          }}
          type={type}
        />
      )}
    />
  );
}

NotesRow.propTypes = {
  note: PropTypes.string,
  timestamp: PropTypes.string.isRequired,
  tags: PropTypes.arrayOf(PropTypes.string),
  user: PropTypes.object, // Assuming 'user' is an object
  date: PropTypes.string,
  isCurrentUser: PropTypes.bool,
  hideDivider: PropTypes.bool,
  unread: PropTypes.bool,
  files: PropTypes.arrayOf(PropTypes.object), // Assuming 'files' is an array of objects
  onPostClick: PropTypes.func,
  type: PropTypes.string,
  canEdit: PropTypes.bool,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  lastEditedDate: PropTypes.object,
  lastEditedByName: PropTypes.string,
};
